export const mapAccessEnvironments = {
  dev: {
    key: 'TM2pXFvg40RqJw8wnaQ-sHNDoA2xfaP1IV2uMklNa-M',
    token: 'pk.eyJ1IjoicWZhbmciLCJhIjoiY2p5NjJ3OHNqMGUydDNibXpvZzdodzNsaCJ9.HAK1XLZht400oO5Q_19LsQ',
    url: 'https://map-api-dev.abmi.ca/'
  },
  prod: {
    key: 'zUfmKbZHvKtswiaL8HJLVdy3sAXuvCI4RVxZ3uzr9KM',
    token: 'pk.eyJ1IjoicWZhbmciLCJhIjoiY2p5NjJ3OHNqMGUydDNibXpvZzdodzNsaCJ9.HAK1XLZht400oO5Q_19LsQ',
    url: 'https://map-api-prod.abmi.ca/'
  }
};

export const mapAccess = { ...mapAccessEnvironments.dev };

// Accepts "dev" | "prod", or an object like { env: "prod", key: "..." } where
// any extra fields override the chosen environment.
export function configureMapAccess(options) {
  const { env, ...overrides } = typeof options === 'string' ? { env: options } : (options ?? {});
  if (env !== undefined) {
    const preset = mapAccessEnvironments[env];
    if (!preset) {
      throw new Error(`Unknown map environment "${env}". Use one of: ${Object.keys(mapAccessEnvironments).join(', ')}`);
    }
    Object.assign(mapAccess, preset);
  }
  Object.assign(mapAccess, overrides);
  return mapAccess;
}
